import React from 'react';
import { FeatureListItem } from '../../journey/FeatureListItem';
import { PricingOption } from '../../journey/PricingOption';
import { MobileFeatureListItem } from '../../journey/MobileFeatureListItem';

type Props = {};

export const HighSchoolSubscriptions: React.FC<Props> = () => {
    const features: FeatureListItem[] = [
        {
            label: 'Searchable by Colleges',
            description: 'Appear in collegiate coach search results (member colleges only)',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Custom School Profile',
            description: "Create your own school's profile & display contact information and team rosters.",
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Display trophies & accolades within profile',
            description:
                'Ability to display your contact information for only member & approved colleges on the platform.',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'College Database',
            description:
                'Ability to see the college database and college profile pages for all colleges on the platform.',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'College Profile with Interaction Buttons',
            description:
                'Ability to see and use the interaction buttons such as follow and message directly on the college profile page. ',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Event Registration',
            description:
                'Sign up for recruiting events with colleges watching! Events include weekly cash tournaments, recruiting showcases and LAN events with live colleges present (some events may require a ticket purchase).',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Introductory Meetings with a Recruting Specialist',
            description: 'Discuss recruiting opportunities directly with a recruiting specialist.',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Continuous Individual Meetings with a Recruting Specialist',
            description:
                'You and your students can talk directly with a recruiting specialist throughout your entire recruiting process. Our experts can help answer questions, help find the right fit college for your students and keep you up to date on any opportunities that may fit your students.',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Featured in Recruiting Content',
            description:
                'Featured in recruitng montages, vidoes, and written articles sent directly to colleges to highlight your recent performances!',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Unique Content & News',
            description:
                'Continuous content that has all recruiting updates on new opportunities & new scholarship opportunities. Also included is educational material to help streamline the recruiting process..',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Stay Plugged In Discord',
            description:
                'Access to the Stay Plugged In discord server where you can interact directly with Recruiting Specialists and other recruits to stay up to date on all opportunities.',
            free: { name: 'Silver', included: true },
        },
    ];
    const dashboardFeatures: FeatureListItem[] = [
        {
            label: 'Receive Notifications',
            description:
                'See any new notification in your dashboard inbox for a new profile view, follower, and new message for all your players',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Notification Reports',
            description:
                'Get continuous dashboard updates via email consisting of new profile views, followers, and new conversations',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Profile View Notifications',
            description: 'Ability to see all notifications and WHO they came from.',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Followers',
            description: 'Ability to see the the number of followers with the ID of who they are',
            free: { name: 'Silver', included: true },
        },
        {
            label: 'Messaging - Unlimited',
            description:
                'Ability to send and receive messages to colleges to start the recruiting conversation. - unlimited',
            free: { name: 'Silver', included: true },
        },
    ];

    return (
        <div className="subscriptions">
            <div className="container">
                <div className="pricing-options">
                    <div className="title-container">
                        <h2 className="title">Simple Pricing</h2>
                    </div>
                    <div className="pricing-options-container">
                        <PricingOption
                            monthly={false}
                            label={'Silver'}
                            value={'FREE'}
                            currentPlan={true}
                            ctaLabel={'Current Plan'}
                            hasInterval={false}
                        />
                    </div>
                </div>
                <div className="pricing-feature-comparison high-school">
                    <div className="feature-header high-school">
                        <div className="header-title left">Feature</div>
                        <div className="header-title right">Silver</div>
                    </div>
                    <div className="feature-group high-school">
                        {features.map((feature, index) => (
                            <FeatureListItem key={`feature-list-item-${index}`} feature={feature} />
                        ))}
                    </div>
                    <div className="feature-group-mobile  high-school">
                        {features.map((feature, index) => (
                            <MobileFeatureListItem key={`feature-list-item-${index}`} feature={feature} />
                        ))}
                    </div>
                </div>
                <div className="questions-container">
                    <h2 className="questions-title">Got Questions? Get Answers.</h2>
                    <a href="mailto:info@staypluggedin.com" className="button large-button blue-button">
                        Contact Us
                    </a>
                </div>
            </div>
        </div>
    );
};
